export default function (token) {
  return {
    headers: { Authorization: `JWT ${token || localStorage.getItem('JWT') || sessionStorage.getItem('JWT')}` },
  };
};


// WEBPACK FOOTER //
// ./src/helpers/authorize-request.js